import { Component, OnInit, Input, OnChanges, SimpleChange, ElementRef, Output, EventEmitter } from '@angular/core';
import {Warehouse, Warehouse4} from '../../project/warehouse';
import {Frame4Component} from '../frames/frame4.component';
import * as d3 from 'd3';


@Component({
  selector: 'app-rebar4',
  templateUrl: './rebars.component.html'
})
export class Rebar4Component extends Frame4Component implements OnInit,  OnChanges {

  @Input() calculated: boolean;
  @Output() selected = new EventEmitter<string>();
  @Input() result: any;
  @Input() b: boolean;
  @Input() hbadditional: number;

  constructor(el: ElementRef) {
    super(el);
    this.div = "#rebar";
  }

  ngOnInit(){
    this.width = 400 - this.margin.left - this.margin.right;
    this.height = 400 - this.margin.top - this.margin.bottom;
    this.initFrame();
    this.isInit = true;
  }

  ngOnChanges(){
    if (this.isInit){
      this.svg.selectAll(".b").remove();
      if (this.hbadditional >= 0){
        this.drawB();
      }
    }
    if(this.calculated){
      this.removeRebars();
      this.prepareRebar();
      this.svg.selectAll(".b").remove();
      this.drawB();
      this.drawRebar();
      this.addTextRebar();
      this.addClick();
      if(this.data.has_door) {
        this.addDoor();
      }
    }
  }

  initFrame(){
    this.prepareData();
    this.createFrame();
    this.drawB();
    if(this.calculated){
      this.prepareRebar();
      this.drawRebar();
      this.addTextRebar();
      this.addClick();
    }
    if(this.data.has_door) {
        this.addDoor();
    }
  }

  prepareRebar(){
    this.data['1'] = (this.result && this.result["reinf"]) ? this.result["reinf"]["1"]["envelope"]: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.data['2'] = (this.result && this.result["reinf"]) ? this.result["reinf"]["2"]["envelope"]: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.data['3'] = (this.result && this.result["reinf"]) ? this.result["reinf"]["3"]["envelope"]: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.data['4'] = (this.result && this.result["reinf"]) ? this.result["reinf"]["4"]["envelope"]: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  }

  drawB(){
    let br = this.data.width_l*this.data.slope_l + (this.hbadditional*this.data.factor);
    let bl = (this.hbadditional*this.data.factor);
    if(this.b){
      let b = this.svg.append("line")
        .style("stroke", "#68a2ff")
        .style("stroke-width", 3)
        .attr("class", "b")
        .attr("x1", this.origin[0])
        .attr("y1", this.origin[1]-this.data.height_l-this.radio)
        .attr("x2", this.origin[0])
        .attr("y2", this.origin[1]-this.data.height_l-this.radio-bl);
      b = this.svg.append("line")
        .style("stroke", "#68a2ff")
        .style("stroke-width", 3)
        .attr("class", "b")
        .attr("x1", this.origin[0]+this.data.width_l)
        .attr("y1", this.origin[1]-this.data.height_r-this.radio)
        .attr("x2", this.origin[0]+this.data.width_l)
        .attr("y2", this.origin[1]-this.data.height_r-this.radio-br);
    } else {
      this.svg.selectAll(".b").remove();
    }
  }

  addDoor(){
    let width = this.data.opening_width;
    let height = this.data.opening_height;
    let padding = (this.data.width_l - width)/2;
    let d1 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "d1")
      .attr("x1", this.origin[0] + padding)
      .attr("y1", this.origin[1])
      .attr("x2", this.origin[0] + padding)
      .attr("y2", this.origin[1] - height);
    let d2 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "d2")
      .attr("x1", this.origin[0] + padding)
      .attr("y1", this.origin[1] - height)
      .attr("x2", this.origin[0] + padding + width)
      .attr("y2", this.origin[1] - height);
    let d3 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "d3")
      .attr("x1", this.origin[0] + padding + width)
      .attr("y1", this.origin[1] - height)
      .attr("x2", this.origin[0] + padding + width)
      .attr("y2", this.origin[1]);
    let circle1 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0] + padding)
      .attr("cy", this.origin[1])
      .attr("r", this.radio);
    let circle2 = this.svg.append("circle")
    .style("fill", "#77768d")
      .attr("cx", this.origin[0] + padding)
      .attr("cy", this.origin[1] - height)
      .attr("r", this.radio);
    let circle3 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0] + padding + width)
      .attr("cy", (this.origin[1] - height))
      .attr("r", this.radio);
    let circle4 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0] + padding + width)
      .attr("cy", this.origin[1])
      .attr("r", this.radio);
  }

  drawRebar(){

    //l1
    let stepdy = (this.data.height_l-this.radio*2)/11;
    for(let i = 0; i < this.data['1'].length; i++){
      if(this.data['1'][i] > 0){
        let rebar = this.svg.append("line")
          .style("stroke", "#77768d")
          .style("stroke-width", 6)
          .attr("class", "rebar")
          .attr("x1", this.origin[0]-7)
          .attr("y1", this.origin[1]-this.radio-i*stepdy)
          .attr("x2", this.origin[0]-7)
          .attr("y2", this.origin[1]-this.radio-(i+1)*stepdy);
      }
    }

    //l2
    let step = Math.sqrt((this.data.width_l/2)*(this.data.width_l/2)+(this.data.width_l/2)*(this.data.width_l/2)*this.data.slope_l*this.data.slope_l)/11-this.radio*2/11-2/11;
    let stepdx = Math.cos(Math.atan(this.data.slope_l))*step;
    stepdy = Math.sin(Math.atan(this.data.slope_l))*step;
    let wdx = Math.sin(Math.atan(this.data.slope_l))*8;
    let wdy = Math.cos(Math.atan(this.data.slope_l))*8;
    let rdx = (this.radio+2)/Math.sqrt(1+this.data.slope_l*this.data.slope_l);

    for(let i = 0; i < this.data['2'].length; i++){
      if(this.data['2'][i] > 0){
        let rebar = this.svg.append("line")
          .style("stroke", "#77768d")
          .style("stroke-width", 6)
          .attr("class", "rebar")
          .attr("x1", this.origin[0]+i*stepdx-wdx+rdx)
          .attr("y1", this.origin[1]-this.data.height_l+i*stepdy-wdy-rdx*this.data.slope_l)
          .attr("x2", this.origin[0]+(i+1)*stepdx-wdx+rdx)
          .attr("y2", this.origin[1]-this.data.height_l+(i+1)*stepdy-wdy-rdx*this.data.slope_l);
      }
    }

    //l3
    step = Math.sqrt((this.data.width_l/2)*(this.data.width_l/2)+(this.data.width_l/2)*(this.data.width_l/2)*this.data.slope_l*this.data.slope_l)/11-this.radio*2/11-2/11;
    stepdx = Math.cos(Math.atan(this.data.slope_l))*step;
    stepdy = Math.sin(Math.atan(this.data.slope_l))*step;
    wdx = Math.sin(Math.atan(this.data.slope_l))*8;
    wdy = Math.cos(Math.atan(this.data.slope_l))*8;
    rdx = (this.radio+2)/Math.sqrt(1+this.data.slope_l*this.data.slope_l);

    for(let i = 0; i < this.data['3'].length; i++){
      if(this.data['3'][i] > 0){
        let rebar = this.svg.append("line")
          .style("stroke", "#77768d")
          .style("stroke-width", 6)
          .attr("class", "rebar")
          .attr("x1", this.origin[0]+this.data.width_l/2+i*stepdx-wdx+rdx)
          .attr("y1", this.origin[1]-this.data.height_l+this.data.width_l/2*this.data.slope_l+i*stepdy-wdy-rdx*this.data.slope_l)
          .attr("x2", this.origin[0]+this.data.width_l/2+(i+1)*stepdx-wdx+rdx)
          .attr("y2", this.origin[1]-this.data.height_l+this.data.width_l/2*this.data.slope_l+(i+1)*stepdy-wdy-rdx*this.data.slope_l);
      }
    }

    //l4
    stepdy = (this.data.height_r-this.radio*2)/11;
    for(let i = 0; i < this.data['4'].length; i++){
      if(this.data['4'][i] > 0){
        let rebar = this.svg.append("line")
          .style("stroke", "#77768d")
          .style("stroke-width", 6)
          .attr("class", "rebar")
          .attr("x1", this.origin[0]+this.data.width_l+7)
          .attr("y1", this.origin[1]-this.radio-i*stepdy)
          .attr("x2", this.origin[0]+this.data.width_l+7)
          .attr("y2", this.origin[1]-this.radio-(i+1)*stepdy);
      }
    }

  }

  addTextRebar(){

    //l1
    let stepdy = (this.data.height_l-this.radio*2)/11;

    let max = 0;
    let init = 0;
    for(let i = 0; i <= this.data['1'].length; i++){
      if(this.data['1'][i] > max){
        max = this.data['1'][i];
      }
      if(max !== 0 && (this.data['1'][i] === 0  || i === this.data['1'].length)){
        let l1 = this.svg.append("text")
          .text(max+"[mm]")
          .attr("font-size", this.fontsize)
          .attr("fill", "#77768d")
          .attr("text-anchor", "middle")
          .attr("class", "rebar")
          .attr("transform", "translate("+(this.origin[0]-15)+","+(this.origin[1]-(init*stepdy)-(i+1-init)*(stepdy)/2)+") rotate(-90)");
        max = 0;
      }
      if(this.data['1'][i] === 0){
        init = i+1;
      }
    }

    //l2
    let step = Math.sqrt((this.data.width_l/2)*(this.data.width_l/2)+(this.data.width_l/2)*(this.data.width_l/2)*this.data.slope_l*this.data.slope_l)/11-this.radio*2/11-2/11;
    let stepdx = Math.cos(Math.atan(this.data.slope_l))*step;
    stepdy = Math.sin(Math.atan(this.data.slope_l))*step;
    let wdx = Math.sin(Math.atan(this.data.slope_l))*15;
    let wdy = Math.cos(Math.atan(this.data.slope_l))*15;

    max = 0;
    init = 0;
    for(let i = 0; i <= this.data['2'].length; i++){
      if(this.data['2'][i] > max){
        max = this.data['2'][i];
      }
      if(max !== 0 && (this.data['2'][i] === 0  || i === this.data['2'].length)){
        let l1 = this.svg.append("text")
          .text(max+"[mm]")
          .attr("font-size", this.fontsize)
          .attr("fill", "#77768d")
          .attr("text-anchor", "middle")
          .attr("class", "rebar")
          .attr("transform", "translate("+(this.origin[0]+(init*stepdx)+(i-init+1)*stepdx/2-wdx)+","+
                (this.origin[1]-this.data.height_l+(init*stepdy)+(i-init+1)*(stepdy)/2-wdy)+") rotate("+(Math.atan(this.data.slope_l)*180/Math.PI)+")");
        max = 0;
      }
      if(this.data['2'][i] === 0){
        init = i+1;
      }
    }

    //l3
    step = Math.sqrt((this.data.width_l/2)*(this.data.width_l/2)+(this.data.width_l/2)*(this.data.width_l/2)*this.data.slope_l*this.data.slope_l)/11-this.radio*2/11-2/11;
    stepdx = Math.cos(Math.atan(this.data.slope_l))*step;
    stepdy = Math.sin(Math.atan(this.data.slope_l))*step;
    wdx = Math.sin(Math.atan(this.data.slope_l))*15;
    wdy = Math.cos(Math.atan(this.data.slope_l))*15;

    max = 0;
    init = 0;
    for(let i = 0; i <= this.data['3'].length; i++){
      if(this.data['3'][i] > max){
        max = this.data['3'][i];
      }
      if(max !== 0 && (this.data['3'][i] === 0  || i === this.data['3'].length)){
        let l1 = this.svg.append("text")
          .text(max+"[mm]")
          .attr("font-size", this.fontsize)
          .attr("fill", "#77768d")
          .attr("text-anchor", "middle")
          .attr("class", "rebar")
          .attr("transform", "translate("+(this.origin[0]+this.data.width_l/2+(init*stepdx)+(i-init+1)*stepdx/2-wdx)+","+
                (this.origin[1]-this.data.height_l+(this.data.width_l/2*this.data.slope_l)+(init*stepdy)+(i-init+1)*(stepdy)/2-wdy)+") rotate("+(Math.atan(this.data.slope_l)*180/Math.PI)+")");
        max = 0;
      }
      if(this.data['3'][i] === 0){
        init = i+1;
      }
    }

    //l4
    stepdy = (this.data.height_r-this.radio*2)/11;

    max = 0;
    init = 0;
    for(let i = 0; i <= this.data['4'].length; i++){
      if(this.data['4'][i] > max){
        max = this.data['4'][i];
      }
      if(max !== 0 && (this.data['4'][i] === 0  || i === this.data['4'].length)){
        let l1 = this.svg.append("text")
          .text(max+"[mm]")
          .attr("font-size", this.fontsize)
          .attr("fill", "#77768d")
          .attr("text-anchor", "middle")
          .attr("class", "rebar")
          .attr("transform", "translate("+(this.origin[0]+this.data.width_l+21)+","+(this.origin[1]-(init*stepdy)-(i-init+1)*(stepdy)/2)+") rotate(-90)");
        max = 0;
      }
      if(this.data['4'][i] === 0){
        init = i+1;
      }
    }
  }

  addClick(){
    this.svg.selectAll(".line").on("mouseover", function(d){
      d3.select(this).style("stroke-width", 8).style("cursor", "pointer");
    }).on("mouseleave", function(d){
      d3.select(this).style("stroke-width", 5);
    })

    this.svg.selectAll(".l1").on("click", () => {
      this.selected.emit('1');
    });
    this.svg.selectAll(".l2").on("click", () => {
      this.selected.emit('2');
    });
    this.svg.selectAll(".l3").on("click", () => {
      this.selected.emit('3');
    });
    this.svg.selectAll(".l4").on("click", () => {
      this.selected.emit('4');
    });

  }

  removeRebars(){
    this.svg.selectAll(".rebar").remove();
    this.svg.selectAll(".text").remove();
  }
}



// WEBPACK FOOTER //
// ./src/app/sketch/rebars/rebar4.component.ts